import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";
import { ReportCenterSharedModule } from "../report-center-shared/report-center-shared.module";
import { EmbargoManagementPageComponent } from "./embargo-management-page/embargo-management-page.component";
import { EmbargoManagementGridComponent } from "./embargo-management-grid/embargo-management-grid.component";
import { EmbargoOverrideModalComponent } from "./embargo-override-modal/embargo-override-modal.component";
import { EmbargoExportModalComponent } from "./embargo-export-modal/embargo-export-modal.component";
import { EmbargoDeleteModalComponent } from "./embargo-delete-modal/embargo-delete-modal.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
const embargoManagementRoutes: Routes = [
  {
    path: "embargomanagement",
    component: EmbargoManagementPageComponent,
    data: {
      title: "Embargo Management",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(embargoManagementRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class EmbargoManagementRoutingModule {}

@NgModule({
  declarations: [
    EmbargoManagementPageComponent,
    EmbargoManagementGridComponent,
    EmbargoOverrideModalComponent,
    EmbargoExportModalComponent,
    EmbargoDeleteModalComponent,
  ],
  imports: [
    CommonModule,
    EmbargoManagementRoutingModule,
    IconsModule,
    SharedModule,
    FormsModule,
    ReportCenterSharedModule,
    NzModalModule,
    NzSelectModule,
    NzButtonModule,
    NzTableModule,
    NzToolTipModule,
    NzGridModule,
    NzInputModule,
    NzModalModule,
    NzCheckboxModule,
    NzSwitchModule,
  ],
})
export class EmbargoManagementPageModule {}
